import { types } from "../types/types";

export const getUpdateHoldingCashFlowNeeded = (values) => ({
  type: types.getUpdateHoldingCashFlowNeeded,
  payload: values,
});

export const getUpdateHoldingCashFlowStructureNeeded = (values) => ({
    type: types.updateHoldingCashFlowStructure,
    payload: values,
  });

export const importUpdateHoldingCashFlowNeeded = (values) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdateHoldingCashFlowNeeded(values));
    } catch (error) {
      console.error(error);
    }
  };
};